module.exports = __webpack_public_path__ + "img/icon63.f30d09f7.png";